export const RegisterForm = () => {
  return <>This is RegisterForm</>;
};
